import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { appInsights } from './ApplicationInsightsService';
import { getAccessToken } from './authService';

class SignalRService {
    private connection: HubConnection | null = null;

    public async startConnection(hubUrl: string): Promise<void> {
        try {
            this.connection = new HubConnectionBuilder()
                .withUrl(`${process.env.REACT_APP_API_URL}${hubUrl}`,
                    {
                        accessTokenFactory: async () => {
                            const token = await getAccessToken();
                            return token;
                        }
                    }
                )
                .withAutomaticReconnect()
                .configureLogging(LogLevel.Information)
                .build();

            await this.connection.start();

            appInsights.trackEvent({ name: 'SignalR Connection Started' });
        } catch (error) {
            console.error('Error starting SignalR connection: ', error);
            appInsights.trackException({ exception: error as Error });
            throw error;
        }
    }

    public onEvent<T>(eventName: string, callback: (data: T) => void): void {
        if (!this.connection) {
            throw new Error('Connection not started');
        }
        this.connection.on(eventName, callback);
    }

    public async invoke(methodName: string, ...args: any[]): Promise<void> {
        if (!this.connection) {
            throw new Error('Connection not started');
        }
        try {
            await this.connection.invoke(methodName, ...args);
        } catch (error) {
            console.error(`Error invoking method ${methodName}: `, error);
            appInsights.trackException({ exception: error as Error });
            throw error;
        }
    }

    public async stop(): Promise<void> {
        if (this.connection) {
            await this.connection.stop();
            this.connection = null;
        }
    }
}

export const signalRService = new SignalRService();